module.exports = __webpack_public_path__ + "img/entertainment-lighting.d773944.jpg";